import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LongPressDirective } from './long-press.directive';
import { TranslationModule } from '../shared/translation.module';

@NgModule({
  declarations: [LongPressDirective],
  imports: [CommonModule, TranslationModule],
  exports: [LongPressDirective, TranslationModule],
})
export class DirectivesModule {}

